<div
    #wysiwygText
    [style.padding-block-start]="textPaddingTop"
    [style.padding-block-end]="textPaddingBottom"
    [style.padding-inline-start]="textPaddingLeft"
    [style.padding-inline-end]="textPaddingRight"
    [innerHTML]="html | renderLinkTransformer"
></div>
